import { useQuery } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementLanguagesQueryKey } from '../queryKeys';
import { CustomerAgreementLanguage } from '../types';

export function useCustomerAgreementLanguagesQuery() {
    return useQuery<CustomerAgreementLanguage[]>(
        [CustomerAgreementLanguagesQueryKey],
        () => CustomerAgreementsApi.getLanguages(),
        { staleTime: Infinity, refetchOnWindowFocus: false }
    );
}
